import { get } from 'lodash';
import { Record } from 'immutable';

import { TestimonialResponse } from '~/types/models/testimonial';
import { getRichTextFromSlateData, RichText, SlateData } from '@vimily/bonjoro-ui-components-v2/RichTextEditor';

export const ResponseRecord = Record(
  {
    uuid: undefined,
    type: undefined,
    text_response: undefined,
    text_response_rich: undefined,
    thumbnail: undefined,
    thumbnail_url: undefined,
    video_url: undefined,
    updated_at: undefined,
  },
  'ResponseRecord'
);

export interface ResponseProps extends Partial<TestimonialResponse> {
  thumbnail?: Blob;
}

export default class Response extends ResponseRecord {
  constructor(args: ResponseProps) {
    super({
      ...args,
      uuid: get(args, 'uuid'),
      type: get(args, 'type'),
      text_response: get(args, 'text_response'),
      text_response_rich: get(args, 'text_response_rich'),
      thumbnail_url: get(args, 'thumbnail_url'),
      video_url: get(args, 'video_url'),
      thumbnail: get(args, 'thumbnail'),
      updated_at: get(args, 'updated_at'),
    });
  }

  getTextResponse(): RichText {
    return getRichTextFromSlateData(
      this.get('text_response_rich') as SlateData[]
    );
  }
}
